import { Box, Divider, VStack } from "@chakra-ui/react";
import { IoSettings, IoPerson } from "react-icons/io5";
import { RiLockPasswordFill } from "react-icons/ri";
import { BsBuildingsFill } from "react-icons/bs";
import { GrAppsRounded } from "react-icons/gr";
import NavbarButton from "./navbarButton";

const sections = [
    [
        {
            icon: <IoPerson />,
            content: "Profile",
            to: "/settings/profile",
        },
        { icon: <IoSettings />, content: "Account", to: "/settings/account" },
        {
            icon: <RiLockPasswordFill />,
            content: "Password and authentication",
            to: "/settings/security",
        },
        {
            icon: <BsBuildingsFill />,
            content: "Organizations",
            to: "/settings/organizations",
        },
        {
            icon: <GrAppsRounded />,
            content: "Applications",
            to: "/settings/applications",
        },
    ],
];

const Navbar = () => {
    return (
        <VStack
            maxWidth={"700px"}
            justifyContent={"flex-start"}
            gap={0}
            width={"20rem"}
        >
            {sections.map((section, i) => {
                return (
                    <Box key={i}>
                        {section.map(({ icon, content, to }, i) => (
                            <NavbarButton
                                key={i}
                                icon={icon}
                                content={content}
                                to={to}
                            />
                        ))}
                        {i !== sections.length - 1 && <Divider />}
                    </Box>
                );
            })}
        </VStack>
    );
};

export default Navbar;
